import React, { useEffect, useState } from "react";
import { cn } from "@/lib/utils";

function parts(ms) {
  const clamp = Math.max(0, ms);
  const s = Math.floor(clamp / 1000);
  return {
    d: Math.floor(s / 86400),
    h: Math.floor((s % 86400) / 3600),
    m: Math.floor((s % 3600) / 60),
    s: s % 60,
    done: clamp <= 0,
  };
}

const pad = (n) => String(n).padStart(2, "0");

// Live countdown to a target ISO datetime. Ticks every second.
export function Countdown({ target, variant = "boxes", className, onDone }) {
  const [ms, setMs] = useState(() => new Date(target).getTime() - Date.now());

  useEffect(() => {
    const t = setInterval(() => {
      const next = new Date(target).getTime() - Date.now();
      setMs(next);
      if (next <= 0) onDone?.();
    }, 1000);
    return () => clearInterval(t);
  }, [target, onDone]);

  const p = parts(ms);

  if (variant === "inline") {
    return (
      <span data-testid="countdown" className={cn("font-mono tabular-nums", className)}>
        {p.d > 0 && `${p.d}d `}
        {pad(p.h)}:{pad(p.m)}:{pad(p.s)}
      </span>
    );
  }

  const segs = p.d > 0
    ? [
        { v: p.d, l: "days" },
        { v: p.h, l: "hrs" },
        { v: p.m, l: "min" },
      ]
    : [
        { v: p.h, l: "hrs" },
        { v: p.m, l: "min" },
        { v: p.s, l: "sec" },
      ];

  return (
    <div data-testid="countdown" className={cn("flex items-center gap-2", className)}>
      {segs.map((s, i) => (
        <div
          key={i}
          className="flex min-w-[52px] flex-col items-center rounded-xl bg-black/55 px-2.5 py-1.5 backdrop-blur-md"
        >
          <span className="font-heading text-lg font-extrabold tabular-nums leading-none text-white">
            {pad(s.v)}
          </span>
          <span className="mt-0.5 text-[10px] font-medium uppercase tracking-wide text-white/60">
            {s.l}
          </span>
        </div>
      ))}
    </div>
  );
}

export default Countdown;
